module.exports = __webpack_public_path__ + "static/media/Salamence_gaussian2.a8b10eee.png";